<template>
  <div id="app">
    <HeaderView v-if="currentRouteName != 'lineitem'" />
    <router-view />
    <FooterView v-if="currentRouteName != 'lineitem'" />
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "header-view",
  components: {
    HeaderView,
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
    if (this.$route.query.utm_source) {
      window.utm_source = this.$route.query.utm_source;
    }
    this.setStats();
  },
  methods: {
    setStats() {
      const scriptElement = document.createElement("script");
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.src = "https://eu.umami.is/script.js";
      scriptElement.dataset.websiteId = '1eab8eef-8506-4689-9846-77fa54be51ac';
      scriptElement.dataset.doNotTrack = "true";
      scriptElement.dataset.autoTrack = "true";
      document.body.append(scriptElement);
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
